import {
    InjectionToken
}
from '@angular/core';

export const BaseEndpoint = new InjectionToken('BaseEndpoint');